import React from 'react';

// Inline SVG icons for the directory tree. Each is decorative — the row's text
// label carries the accessible name — so they render with aria-hidden. They
// inherit color via `currentColor` and size to 1em so they track row text.
//
// Folder open/closed distinguish the active folder column; Document marks a
// leaf. (The earlier inline-expand model used a Chevron; the two-column Miller
// layout has no per-row expand affordance, so it was removed.)

const baseProps = {
  width: '1em',
  height: '1em',
  viewBox: '0 0 16 16',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.25,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
};

export function FolderClosed() {
  return (
    <svg {...baseProps}>
      <path d="M1.5 4.5 a1 1 0 0 1 1-1 h3.2 l1.3 1.4 h6.5 a1 1 0 0 1 1 1 v6.6 a1 1 0 0 1-1 1 h-11 a1 1 0 0 1-1-1 z" />
    </svg>
  );
}

export function FolderOpen() {
  return (
    <svg {...baseProps}>
      <path d="M1.5 4.5 a1 1 0 0 1 1-1 h3.2 l1.3 1.4 h6.5 a1 1 0 0 1 1 1 v1.1 h-11.6 l-1.4 6.5 z" />
      <path d="M2.6 13.5 l1.4-6.5 h11.6 l-1.4 6.5 z" />
    </svg>
  );
}

export function Document() {
  return (
    <svg {...baseProps}>
      <path d="M4 1.5 h5 l3 3 v9.5 a0.5 0.5 0 0 1-0.5 0.5 h-7.5 a0.5 0.5 0 0 1-0.5-0.5 v-12 a0.5 0.5 0 0 1 0.5-0.5 z" />
      <path d="M9 1.5 v3 h3" />
      <path d="M5.5 8.5 h5" />
      <path d="M5.5 11 h5" />
    </svg>
  );
}

